import { Link } from 'react-router-dom';

export default function Footer() {
  return (
   <footer className="glass-footer">
  <div className="footer-glow-effect"></div>
  
  <div className="container">
    <div className="footer-content">
      {/* Left: Brand */}
      <div className="footer-brand">
        <Link to="/" className="footer-logo">
        <img src="../../img/logo.webp" className="img-fluid" alt="logo" width="50" />

        </Link>
        <div className="footer-social">
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <i className="bi bi-instagram"></i>
          </a>
         
        </div>
      </div>
      
      {/* Right: Single Row Links */}
      <nav className="footer-nav">
        <Link to="/">HOME</Link>
        <Link to="/discover">DISCOVER</Link>
        <Link to="/for-brands">FOR BRANDS</Link>
        <Link to="/about">ABOUT US</Link>
       
      </nav>
    </div>
    
    {/* Bottom Bar */}
    <div className="footer-bottom">
      <span>© 2026 <Link className="text-white text-decoration-none" to="https://www.outfitfind.co/">OutFitFind</Link>. All rights reserved.</span>
    </div>
  </div>
</footer>
  );
}